/* eslint-disable import/extensions */
/* eslint-disable redux-saga/yield-effects */
import { call, put, all, spawn, takeLatest } from 'redux-saga/effects';
// import type { PayloadAction } from '@reduxjs/toolkit';

import {
  CANCEL_NEW_BANK_ACCOUNT_URL,
  CREATE_SELF_SERVE_TICKET_URL,
  GET_PAYOUT_BANK_IDS_URL,
  VERIFY_BANK_ACCOUNT_URL,
} from 'constants/url';

import {
  GET_BANK_ACCOUNTS,
  GET_BANK_ACCOUNTS_URL,
  GET_REFUND_RECHARGE,
  GET_REFUND_RECHARGE_URL,
  VERIFY_BANK_ACCOUNT,
  CANCEL_NEW_BANK_ACCOUNT,
  GET_PAYOUT_BANK_IDS,
  CREATE_SELF_SERVE_TICKET,
  GET_BANK_ACCOUNTS_DETAILS,
} from './constants';

import {
  GET_RECHARGE_BANK_DETAILS_URL,
  GET_RECHARGE_BALANCE_URL,
} from '../../utils/constants';

import request from '../../utils/request';
import { showToast } from '../Toast/actions';

import {
  disableLoaderAction,
  saveBankAccountsResponse,
  saveRefundRechargeAction,
} from './actions';

// Types
import { CreateCancelTicketPayload, IVerifyBankAccount, Payload } from './types';

export function* getSettlementsBankAccounts({ data }: any) {
  try {
    const { cbs } = data;
    const promiseArr = [
      GET_BANK_ACCOUNTS_URL,
      GET_RECHARGE_BALANCE_URL,
      GET_RECHARGE_BANK_DETAILS_URL,
    ].map((obj) => call(request, obj));
    cbs?.forEach((cb) => promiseArr.push(call(cb)));
    const response = yield all(promiseArr);
    yield put(saveBankAccountsResponse(response));
  } catch (err) {
    yield put(disableLoaderAction({}));
    yield put(showToast(err));
  }
}

export function* getBankAccountDetails({data:{cb}}:any) {
  try {
    const options = {
      method:"GET",
    }
    const response = yield call(request, GET_BANK_ACCOUNTS_URL, options);
    cb?.(response);
  } catch (err) {
    yield put(showToast(err));
  }
 
}


export function* getPayoutBankAccounts({ data }: Payload) {
  try {
    const { cb } = data;
    const { url, method } = GET_PAYOUT_BANK_IDS_URL;
    const options = {
      method,
    }
    const response = yield call(request, url, options);
    cb?.(response);
  } catch (err) {
    yield put(showToast(err));
  }
  finally {
    data?.finalCb?.();
  }
}

export function* verifyBankAccount({ data }: Payload<IVerifyBankAccount>) {
  try {
    const { payload, cb } = data;
    const { url, method } = VERIFY_BANK_ACCOUNT_URL;
    const options = {
      method,
      body: JSON.stringify(payload),
      useBasePath: true,
    };
    yield call(request, url, options);
    cb?.();
  } catch (err) {
    if (data.errorCb) data.errorCb(err?.errorMeta);
  } finally {
    data?.finalCb?.();
  }
}

export function* createSelfServeTicket({ data }: Payload<CreateCancelTicketPayload>) {
  try {
    const { payload, cb } = data;
    const { url, method } = CREATE_SELF_SERVE_TICKET_URL;
    const options = {
      method,
      body: JSON.stringify(payload),
      useBasePath: true,
    };
    yield call(request, url, options);
    cb?.();
  } catch (err) {
    yield put(showToast(err));
  } finally {
    data?.finalCb?.();
  }
}
export function* cancelNewBankAccount({ data }: Payload) {
  try {
    const { cb } = data;

    const { url, method } = CANCEL_NEW_BANK_ACCOUNT_URL;
    const options = {
      method,
      useBasePath: true,
    };
    yield call(request, url, options);
    cb?.();
  } catch (err) {
    yield put(showToast(err));
  } finally {
    yield put(disableLoaderAction({}));
  }
}
// type Payload = {
//   data: { options: any; cb?: any };
//   type: string;
// };

export function* getRefundRecharge({ data }: any) {
  try {
    const { options: reqOptions, cb } = data;
    const { url, method } = GET_REFUND_RECHARGE_URL;
    const options = {
      method,
      queryString: reqOptions || {},
    };
    const response = yield call(request, url, options);
    yield put(
      saveRefundRechargeAction({ ...response, pageNo: reqOptions.pageNo }),
    );
    if (cb) cb();
  } catch (err) {
    yield put(disableLoaderAction({}));
    yield put(disableLoaderAction('REFUND_RECHARGE'));
    yield put(showToast(err));
  }
}

export function* getRefundRechargeSaga() {
  yield takeLatest(GET_REFUND_RECHARGE, getRefundRecharge);
}

export function* getSettlementsBankAccountsSaga() {
  yield takeLatest(GET_BANK_ACCOUNTS, getSettlementsBankAccounts);
}

export function* getBankAccountDetailsSaga() {
  yield takeLatest(GET_BANK_ACCOUNTS_DETAILS, getBankAccountDetails);
}

export function* verifyBankAccountSaga() {
  yield takeLatest(VERIFY_BANK_ACCOUNT, verifyBankAccount);
}

export function* cancelNewBankAccountSaga() {
  yield takeLatest(CANCEL_NEW_BANK_ACCOUNT, cancelNewBankAccount);
}

export function* getPayoutBankAccountsSaga() {
  yield takeLatest(GET_PAYOUT_BANK_IDS, getPayoutBankAccounts);
}

export function* createSelfServeTicketSaga() {
  yield takeLatest(CREATE_SELF_SERVE_TICKET, createSelfServeTicket);
}
// Individual exports for testing
export default function* settlementsBankAccountsSaga() {
  // See example in containers/HomePage/saga.js
  const sagas = [
    getSettlementsBankAccountsSaga,
    getRefundRechargeSaga,
    verifyBankAccountSaga,
    cancelNewBankAccountSaga,
    getPayoutBankAccountsSaga,
    createSelfServeTicketSaga,
    getBankAccountDetailsSaga,
  ];

  yield all(
    sagas.map((saga) =>
      // eslint-disable-next-line func-names
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
